export const REGEX = {
  isOnlyLetters: /^[a-zA-Z]+$/,
  isAlphaNumeric: /^[a-z0-9]+$/i,
  isEmail: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
  isSSN: /^\d{9}$/,
  isPhoneNumber: /^\d{10}$/,
  isZIP: /^\d{5}$/,
};
